import jQuery from 'jquery';
import _ from 'lodash';
import URI from 'urijs';
const Pica = require('shared/vendor/pica')();


export const uploadFile = (file, progressCallback) => {
  const data = new FormData();
  data.append('upload', file);
  const jqXHR = jQuery.ajax({
    method: 'POST',
    url: '/allimages/core/connector/php/connector.php?' + jQuery.param({
      'command': 'FileUpload',
      'type': 'Images',
      'currentFolder': '/'
    }),
    contentType: false,
    processData: false,
    data: data,
    timeout: 300 * 1000, // set maximum of 30 seconds per image
    xhr: () => {
      const xhr = new window.XMLHttpRequest();
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const percentComplete = event.loaded / event.total;
          if (progressCallback) {
            progressCallback(percentComplete);
          }
        }
      }, false);
      return xhr;
    }
  });
  jqXHR.fail(console.error.bind(console, 'Upload File'));
  return jqXHR;
};

export const getClearedBackgroundImage = (currentFolder = '/', fileName) => {
  return jQuery.ajax({
    method: 'POST',
    url: '/application/user/clear-image-background',
    data: {currentFolder, fileName},
  });
};

export const deleteFile = (name) => {
  return jQuery.ajax({
    method: 'POST',
    url: '/allimages/core/connector/php/connector.php?' + jQuery.param({
      'command': 'DeleteFiles',
      'type': 'Images',
      'currentFolder': '/'
    }),
    // the duplication of type and current folder matched the ckfinder ui behaviour
    data: {jsonData: JSON.stringify({'files': [
      {
        name: name,
        type: 'Images',
        folder: '/'
      }
    ]} )
    }
  }).fail(console.warn.bind(console, 'Delete File'));
};

export const checkImageSize = (file, callback) => {
  let width;
  let height;
  const img = document.createElement('img');
  img.onload = () => {
    width = img.naturalWidth || img.width;
    height = img.naturalHeight || img.height;
    callback({width, height});
  };
  img.src = window.URL.createObjectURL(file);
};

export const resizePreview = (file, callback, size = 250) => {
  let preview;
  if (_.isString(file)) {
    preview = file;
    callback(preview);
    return;
  }
  preview = window.URL.createObjectURL(file);
  const img = document.createElement('img');
  const srcCanvas = document.createElement('canvas');
  const dstCanvas = document.createElement('canvas');
  dstCanvas.height = size;
  dstCanvas.width = size;
  img.src = preview;
  img.onload = () => {
    let sx;
    let sy;
    let sourceSize;
    if (img.width > img.height) {
      sy = 0;
      sx = (img.width - img.height) / 2;
      sourceSize = img.height;
    } else {
      sx = 0;
      sy = (img.height - img.width) / 2;
      sourceSize = img.width;
    }
    srcCanvas.width = sourceSize;
    srcCanvas.height = sourceSize;
    srcCanvas.getContext('2d').drawImage(img, sx, sy, sourceSize, sourceSize, 0, 0, sourceSize, sourceSize);
    Pica.WEBGL = true;
    try {
      Pica.resize(srcCanvas, dstCanvas)
      .then(dstCanvas => {
        window.URL.revokeObjectURL(preview);
        preview = dstCanvas.toDataURL();
        if (!_.isString(file)) {
          file.preview = preview;
        }
        callback(preview);
      });
    } catch (error) {
      // images that don't allow CORS causes exception when performing toDataURL
    }
  };
};

export function downsizeImage(settings, callback) {
  const file = settings.file;
  const maxSize = settings.maxSize;
  const img = document.createElement('img');
  const srcCanvas = document.createElement('canvas');
  const dstCanvas = document.createElement('canvas');
  img.onload = () => {
    srcCanvas.width = img.width;
    srcCanvas.height = img.height;
    let width = img.width;
    let height = img.height;
    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else {
      if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }
    }
    dstCanvas.width = width;
    dstCanvas.height = height;
    srcCanvas.getContext('2d').drawImage(img, 0, 0);
    Pica.resize(srcCanvas, dstCanvas)
      .then(result => Pica.toBlob(result, file.type))
      .then(blob => callback(blob));
  };
  img.src = window.URL.createObjectURL(file);
}

export const getS3VersionedUrl = (url, callback) => {
  if (_.isEmpty(url)) {
    callback(url);
    return;
  }
  // Use a native XHR so we can use custom responseType
  const xhr = new XMLHttpRequest();
  const splitUrl = url.split('?');
  const clearedUrl = splitUrl[0];
  try { // some browsers throw exception when xhr fail
    xhr.open('HEAD', clearedUrl + '?' + Math.random().toString(36).substring(7), true);
    xhr.onload = function onLoad() {
      const versionId = this.getResponseHeader('x-amz-version-id');
      if (_.isEmpty(versionId)) {
        callback(url);
      } else {
        callback(clearedUrl + '?versionId=' + versionId);
      }
    };
    xhr.onerror = () => {
      callback(url);
    };
    xhr.send();
  } catch (err) {
    callback(url);
  }
};

export const getImage = (src, callback = () => {}) => {
  if (_.isEmpty(src)) {
    _.defer(callback, null); // ensure callers who relay on async behavior will work well.
    return null;
  }
  const img = new Image();
  img.src = src;
  img.onload = () => {
    callback(img);
  };
  img.onerror = (error) => {
    console.warn(error);
    callback(null);
  };
  return img;
};

export const getS3VersionedImage = (src, callback) => {
  getS3VersionedUrl(src, (newSrc) => {
    getImage(newSrc, callback);
  });
};

export const isClearedSrc = (src) => {
  return src.indexOf('.cleared-versionId-') !== -1 && src.indexOf('---') !== -1;
};

export const cleaeredToOriginalSrc = (src) => {
  const url = new URI(src);
  const filename = url.filename();
  const splitedFileName = filename.replace('.cleared-versionId-', '').split('---');
  const amzVersionId = splitedFileName[0];
  url.filename(splitedFileName[1]);
  url.setSearch('versionId', amzVersionId);
  return url.toString();
};

export const isVersionedUrl = (src) => {
  return !_.isEmpty(new URI(src).search(true).versionId);
};

export const originalToCleaeredSrc = (src) => {
  const url = new URI(src);
  const filename = url.filename();
  const amzVersionId = url.search(true).versionId;
  if (_.isEmpty(amzVersionId)) {
    return null;
  }
  url.removeSearch('versionId');
  url.filename('.cleared-versionId-' + amzVersionId + '---' + filename);
  return url.toString();
};

const prefetchQueue = [];
const activePrefetch = [];
function processPrefetchQueue() {
  const MAX_IN_PROGRESS = 5;
  _.remove(activePrefetch, (img) => {return img.complete;});
  const emptySlots = MAX_IN_PROGRESS - _.size(activePrefetch);
  if (emptySlots > 0) {
    for (let i = 0; i < Math.min(emptySlots, _.size(prefetchQueue)); i++) {
      activePrefetch.push(getImage(prefetchQueue.pop(), processPrefetchQueue));
    }
  }
}
export const prefetchImage = (src) => {
  prefetchQueue.splice(0, 0, src);
  processPrefetchQueue();
};

export default {
  uploadFile,
  deleteFile,
  resizePreview,
  getS3VersionedImage,
  isVersionedUrl,
};
